import _createForOfIteratorHelper from "/root/Etro/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import { createStyles, getSize, getBreakpointValue, em } from '@mantine/styles';
import { getSortedBreakpoints } from './get-sorted-breakpoints/get-sorted-breakpoints.js';
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;

var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value
  }) : obj[key] = value;
};

var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }

  if (__getOwnPropSymbols) {
    var _iterator = _createForOfIteratorHelper(__getOwnPropSymbols(b)),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var prop = _step.value;
        if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return a;
};

var useStyles = createStyles(function (theme, _ref) {
  var spacing = _ref.spacing,
      breakpoints = _ref.breakpoints,
      cols = _ref.cols,
      verticalSpacing = _ref.verticalSpacing;
  var hasVerticalSpacing = verticalSpacing != null;
  var gridBreakpoints = getSortedBreakpoints(theme, breakpoints).reduce(function (acc, breakpoint) {
    var _a, _b;

    var property = "maxWidth" in breakpoint ? "max-width" : "min-width";
    var breakpointSize = getSize({
      size: property === "max-width" ? breakpoint.maxWidth : breakpoint.minWidth,
      sizes: theme.breakpoints,
      units: "em"
    });
    var breakpointValue = getBreakpointValue(breakpointSize) - (property === "max-width" ? 1 : 0);
    acc["@media (".concat(property, ": ").concat(em(breakpointValue), ")")] = {
      gridTemplateColumns: "repeat(".concat(breakpoint.cols, ", minmax(0, 1fr))"),
      gap: "".concat(getSize({
        size: (_a = breakpoint.verticalSpacing) != null ? _a : hasVerticalSpacing ? verticalSpacing : spacing,
        sizes: theme.spacing
      }), " ").concat(getSize({
        size: (_b = breakpoint.spacing) != null ? _b : spacing,
        sizes: theme.spacing
      }))
    };
    return acc;
  }, {});
  return {
    root: __spreadValues({
      boxSizing: "border-box",
      display: "grid",
      gridTemplateColumns: "repeat(".concat(cols, ", minmax(0, 1fr))"),
      gap: "".concat(getSize({
        size: hasVerticalSpacing ? verticalSpacing : spacing,
        sizes: theme.spacing
      }), " ").concat(getSize({
        size: spacing,
        sizes: theme.spacing
      }))
    }, gridBreakpoints)
  };
});
export default useStyles;